import { useEffect, useState } from "react";
import ModalComponent from "../../../common/ModalComponent";
import { ToastType } from "../../../../helper/constant";
import CustomDropdown from "../../../common/CustomDropdown";
import { getWorkflowExecutionListAPI, getWorkflowExecutionSchemaAPI, saveWorkflowExecutionData } from "../../../../service/ai-model.service";
import CustomLoader from "../../../common/CustomLoader";
import { DynamicExecutionForm } from "./DynamicExecutionForm";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../../context/app.context";

const WorkflowInput = ({ showModal, setShowModal, onExecute, workflows }) => {
    const [loading, setLoading] = useState(false);
    const { showAlert } = useAppContext();
    const [executionForm, setExecutionForm] = useState({ schema: {}, schema_value: {}, nodeId: '', executionWFName: '', executionId: '' });
    const [edit, setEdit] = useState(false);
    const [selectedExecution, setSelectedExecution] = useState({});


    const renderExectionList = () => {
        if (workflows && workflows.length) {
            return (
                <>
                    {workflows.map((item, index) => {
                        return (
                            <ExecutionItem
                                showModal={showModal}
                                workflowName={item.name}
                                setExecutionForm={setExecutionForm}
                                executionForm={executionForm}
                                edit={edit}
                                setEdit={setEdit}
                                loading={loading}
                                setLoading={setLoading}
                                selectedExecution={selectedExecution}
                                setSelectedExecution={setSelectedExecution}
                                key={index}
                            />
                        )
                    })}
                </>
            )
        }
    }

    const onFormSubmit = (data) => {
        setLoading(true);
        saveWorkflowExecutionData({ ...executionForm, schema_value: data })
            .then(() => showAlert('Workflow execution data saved successfully!', ToastType.SUCCESS))
            .catch(() => showAlert("Error saving workflow execution data:", ToastType.ERROR)
            ).finally(() => setLoading(false));

    }

    const renderExecutionDynamicForm = () => {
        if (executionForm && executionForm.schema && Object.keys(executionForm.schema).length) {
            return (
                <DynamicExecutionForm
                    schema={executionForm.schema}
                    schema_value={executionForm.schema_value}
                    onSubmit={(data) => onFormSubmit(data)} />
            )
        }
    }

    const renderWorkflowInputContent = () => {
        return (
            <div className="d-flex flex-column gap-2">
                <div className="d-flex justify-content-between align-items-start gap-2">
                    <div className="d-flex flex-column gap-2 w-40">
                        <h3 className="text-2xl font-bold mb-3">Workflows</h3>
                        {renderExectionList()}
                    </div>
                    {(executionForm && executionForm.schema && Object.keys(executionForm.schema).length > 0) &&
                        <div className="dynamic-execution-form w-60">
                            <h3 className="text-2xl font-bold mb-3">Workflow data</h3>
                            {edit && renderExecutionDynamicForm()}
                            {(!edit && executionForm.schema_value) &&
                                <div className="d-flex flex-column gap-2">
                                    <pre>{JSON.stringify(executionForm.schema_value, 0, 2)}</pre>
                                </div>
                            }
                        </div>
                    }
                </div>
                <Link type="submit" className="btn2 btn-dragable1 py-2 bg-dark w-80 mx-auto text-center" onClick={() => onExecute(selectedExecution)}>Execute</Link>
            </div>
        )
    }

    const render = () => {
        return (
            <ModalComponent
                full
                title="Workflow Input"
                show={showModal}
                handleClose={setShowModal}
                classes={'w-80'}
            >
                {loading && <CustomLoader full />}
                {renderWorkflowInputContent()}
            </ModalComponent>
        )
    }
    return render();
}


export default WorkflowInput

const ExecutionItem = ({
    showModal,
    workflowName,
    setExecutionForm,
    edit,
    setEdit,
    setLoading,
    selectedExecution,
    setSelectedExecution
}) => {
    const [executionList, setExecutionList] = useState([]);
    const [activeExecution, setActiveExecution] = useState('');
    const { showAlert } = useAppContext();

    useEffect(() => {
        if (showModal) {
            setLoading(true);
            getWorkflowExecutionListAPI({ workflowName })
                .then(result => {
                    if (result && result.executions && result.executions.length) {
                        const list = result.executions.map(((item) => {
                            return {
                                ...item,
                                id: item.name,
                                logTime: item.endTime ? new Date(item.endTime.seconds * 1000).toLocaleString() : ""
                            }
                        }))
                        setExecutionList(list);
                    }
                })
                .catch(err => {
                    console.error("Error fetching workflow execution list:", err);
                })
                .finally(() => setLoading(false));
        }
        return () => {
            setExecutionList([]);
            setActiveExecution(null);
            setExecutionForm({ schema: null, schema_value: null, executionId: '', executionWFName: '', nodeId: '' });
        }
    }, [showModal, workflowName]);

    useEffect(() => {
        if (activeExecution) {
            setLoading(true);
            const executions = { ...selectedExecution };
            executions[workflowName] = activeExecution;
            setSelectedExecution(executions);
            getWorkflowExecutionSchemaAPI({ workflowName: activeExecution })
                .then(res => {
                    if (res && res.schema) {
                        setExecutionForm({ ...res });
                    } else {
                        setExecutionForm({ schema: {}, schema_value: {}, executionWFName: '', executionId: '', nodeId: '' });
                    }
                })
                .catch((err) => {
                    showAlert(`${workflowName}:  Error fetching workflow execution schema`, ToastType.ERROR);
                    setExecutionForm({ schema: {}, schema_value: {}, executionWFName: '', executionId: '', nodeId: '' });
                }).finally(() => setLoading(false));

        }
    }, [activeExecution]);

    const render = () => {
        return (
            <div className="d-flex justify-content-between align-items-end gap-2">
                <div className="d-flex flex-column gap-1 w-100">
                    <h6 className="pb-2">{workflowName}</h6>
                    <CustomDropdown
                        name="Execution"
                        options={executionList}
                        field="logTime"
                        value={activeExecution}
                        onChange={e => setActiveExecution(e)}
                    />
                </div>
                <div className="d-flex justify-content-start align-items-center gap-2 w-25">
                    <Link className="btn2 btn-dragable1 py-3" onClick={() => setEdit(!edit)}>{edit ? 'CANCEL' : 'EDIT'}</Link>
                </div>
            </div>
        )
    }
    return render();
}
